import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/client-logo/3_masseur.png")